import HeaderWrapperDesktop from "../header-wrapper-desktop"
import AptHeaderContent from "../apt-header-content"
import { langStore } from "@/stores/lang-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { headerBundle } from "./monitoring-header-const"

const MonitoringHeaderDesktop = ({ position = "sticky" }) => {
  const { lang } = langStore()
  const { unit_count } = aptSearchStore((s) => s.pickApt)

  return (
    <HeaderWrapperDesktop position={position} useRight={false}>
      <AptHeaderContent label={headerBundle.caption[lang]}>
        <div className="flex items-center gap-4">
          <article className="flex flex-col">
            <span className="text-[11px] text-gray-400 font-medium">
              {headerBundle.label[lang]}
            </span>

            <div className="flex items-end gap-1">
              <span className="text-2xl font-bold text-gray-900 leading-none">
                {unit_count.toLocaleString()}
              </span>

              <span className="text-sm text-gray-500 mb-px">{headerBundle.unit[lang]}</span>
            </div>
          </article>
        </div>
      </AptHeaderContent>
    </HeaderWrapperDesktop>
  )
}

export default MonitoringHeaderDesktop
